export default {
  'Extract audio': 'Extrait audio',
  'Mute': 'Mute',
  'Split video and audio': "Diviser la vidéo et l'audio",
}